module.exports = __webpack_public_path__ + "img/mana1.e038eb9e.png";